import UtilityMove from 'utilitymove/assets/js/UtilityMove';

/**
 * Utility Move Functions
 */
const init = () => {
	'use strict';

	/**
	 * Move the sidnav below content on mobile screens
	 */
	const moveSideNav = () => {
		const primaryContainer = document.getElementById( 'spirit-shell-main' );
		if( ! primaryContainer ) {
			return;
		}

		const sideNavContainer = primaryContainer.querySelector( '.spirit-container--side-nav:first-child' );

		if( ! sideNavContainer ) {
			return;
		}

		const sideNavNav    = sideNavContainer.querySelector( '.jdrf-2-col__nav' );
		const lastContainer = primaryContainer.lastElementChild;

		if( sideNavNav && lastContainer ) {
			UtilityMove( {
				'el'          : sideNavNav,
				'after'       : lastContainer,
				'refreshRate' : 100,
				useMatchMedia : true,
				mediaQuery    : '(max-width: 767px)',
			} );
		}

	};

	moveSideNav();
};

export default {init};


